import React from 'react';

const Wrapper = (props) => {
  return (
    <React.Fragment>
      <div style={{ position: 'relative' }}>
        {window.location.hostname === 'exhibitionz.netlify.app' && (
          <div
            className='text-white text-center bg-danger mb-1'
            style={{
              position: 'fixed',
              top: 0,
              width: '100%',
              textAlign: 'center',
              padding: '5px 0',
              zIndex: 1000,
            }}
          >
            This is DUMMY Link. Stall Booking is not REAL.
          </div>
        )}
        <div style={window.location.hostname === 'exhibitionz.netlify.app' ? { marginTop: '30px' } : {}}>{props.children}</div>
      </div>
    </React.Fragment>
  );
};

export default Wrapper;
